import { ComponentChildren, h } from 'preact'

interface Props {
  title: string
  customClass?: string
  children?: ComponentChildren
}

export const Section = ({ title, customClass, children }: Props) => {
  return (
    <div className={`section-wrapper ${customClass ?? ''}`}>
      <div className='section-header'>
        <div className='section-header-title'>{title}</div>
      </div>
      <div className='section-body'>
        {children}
      </div>
    </div>
  )
}
